import { AxiosInstance } from 'axios'

const requestInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use(
    (config: any) => {
      return config
    },
    (error) => {
      return error
    }
  )
}

export default requestInterceptor
